import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-warning",
  role: "alert"
}

import { computed, toRef } from 'vue'

    import { KendoChart } from '@Kendo/Components/KendoChart'
    import { CriterionSelectorDialogViewModel } from '@Criteria/Hierarchies/Components/CriterionSelectorDialog'
    import CriterionSelectorDialog from '@Criteria/Hierarchies/Components/CriterionSelectorDialog.vue'
    import type { SensitivityAnalysisChartDialogViewModel } from '@Evaluation/ValueAnalysis/Components/SensitivityAnalysisChartDialog'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SensitivityAnalysisChartDialog',
  props: {
    viewModel: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- local state ----------------

    const criterionSelectorDialog = new CriterionSelectorDialogViewModel()

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const chart = computed<KendoChart>(() => vm.value.chart)

    const selectedCriterionName = computed<string | null>(() =>
        vm.value.selectedCriterion?.Name ?? null
    )

    const goalSelected = computed<boolean>(() => vm.value.goalSelected)

    const criterionId = computed<number>({
        get: () => vm.value.criterionId,
        set: val => { vm.value.criterionId = val }
    })

    // ---------------- actions ----------------

    function showCriterionSelector()
    {
        criterionSelectorDialog.show(criterionId.value, vm.value.criteria)
    }

    function handleChangeCriterion(id: number)
    {
        if (id !== criterionId.value)
        {
            criterionId.value = id
            vm.value.setChartData()
        }
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (opened.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", { class: "modal-header" }, [
                  _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Sensitivity analysis", -1 /* CACHED */)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    onClick: close
                  }, "×")
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _cache[1] || (_cache[1] = _createTextVNode("Criterion: ", -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "text-primary",
                        onClick: showCriterionSelector
                      }, _toDisplayString(selectedCriterionName.value), 1 /* TEXT */)
                    ]),
                    (goalSelected.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Please select a criterion. Sensitivity analysis in the context of root is not available. "))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"max-height":"calc(100vh-200px)","overflow":"auto"} }, [
                    _createElementVNode("div", { id: "Chart-SensitivityAnalysisChart" })
                  ], -1 /* CACHED */))
                ]),
                _createElementVNode("div", { class: "modal-footer" }, [
                  _createElementVNode("button", {
                    onClick: close,
                    type: "button",
                    class: "btn btn-outline-secondary"
                  }, "Close")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(CriterionSelectorDialog, {
      viewModel: _unref(criterionSelectorDialog),
      onConfirmSelection: handleChangeCriterion
    }, null, 8 /* PROPS */, ["viewModel"])
  ]))
}
}

})